<template>
  <a-modal
    v-model="dialogVisible"
    title="保函审核"
    :mask-closable="false"
    width="600px"
    @ok="confirm"
    @cancel="cancel"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-suffix="："
      label-width="100px"
    >
      <el-form-item label="审核结果" prop="gfLetterApprovalStatus">
        <el-radio-group v-model="form.gfLetterApprovalStatus">
          <el-radio
            v-for="item in auditStatusDict.array"
            :key="item.value"
            :label="item.value"
          >
            {{ item.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="form.gfLetterApprovalStatus === auditStatusDict.REJECT.value"
        label="审核意见"
        prop="gfLetterApprovalOp"
      >
        <el-input
          v-model="form.gfLetterApprovalOp"
          type="textarea"
          maxlength="200"
          show-word-limit
          :autosize="{ minRows: 8 }"
        />
      </el-form-item>
    </el-form>
  </a-modal>
</template>

<script>
import { requiredRule } from '@/utils/form-validate'
import Dict from '@/utils/dict-utils'
import { auditOfflineLetterApi } from '@/api/procure/invite-bid'

// 审核操作字典
const auditStatusDict = new Dict({
  PASS: { label: '审核通过', value: 2 },
  REJECT: { label: '审核不通过', value: 3 }
})

/**
 * @description 投标电子保函审核弹窗
 */
export default {
  name: 'GuaranteeLetterAudit',

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    // 订单id
    orderId: {
      type: [String, Number],
      required: true
    },

    // 交易id
    tradeId: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      auditStatusDict,

      form: {
        // 审核操作结果
        gfLetterApprovalStatus: '',
        // 审核意见
        gfLetterApprovalOp: ''
      },
      rules: {
        gfLetterApprovalStatus: requiredRule('请选择审核结果'),
        gfLetterApprovalOp: requiredRule('请填写审核意见')
      }
    }
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  methods: {
    cancel() {
      this.$refs.form.clearValidate()
      this.form = {
        gfLetterApprovalStatus: '',
        gfLetterApprovalOp: ''
      }
      this.dialogVisible = false
    },

    confirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        const postData = {
          orderId: this.orderId,
          tradeId: this.tradeId,
          ...this.form
        }
        if (postData.gfLetterApprovalStatus === auditStatusDict.PASS.value) {
          postData.gfLetterApprovalOp = ''
        }
        auditOfflineLetterApi(postData)
          .then(res => {
            this.cancel()
            this.$message.success('已审核')
            this.$emit('after-audit')
          })
          .catch(err => {
            console.error('审核失败', err)
            if (err?.message) this.$message.error(err.message)
          })
      })
    }
  }
}
</script>

<style scoped></style>
